import { Box } from "@chakra-ui/react-v3";
import { parseSearchQuery } from "../../../search";

export function HighlightedText({ text, searchQuery }: { text: string; searchQuery: string }) {
  const trimmedQuery = searchQuery.trim();

  if (!trimmedQuery) {
    return <>{text}</>;
  }

  // Parse query respecting quoted phrases
  const tokens = parseSearchQuery(trimmedQuery).map(escapeRegex);

  if (tokens.length === 0) {
    return <>{text}</>;
  }

  // Create regex that matches any of the tokens (case-insensitive)
  const regex = new RegExp(`(${tokens.join("|")})`, "gi");
  const parts = text.split(regex);

  return (
    <Box display="inline-block">
      {parts.map((part, index) => {
        // Check if this part matches any token (case-insensitive)
        const isMatch = tokens.some(token => part.toLowerCase() === token.toLowerCase());

        if (isMatch) {
          return (
            <Box
              key={index}
              as="span"
              bg="highlight.bg"
              color="highlight.fg"
              px={0}
              borderRadius="sm"
              fontWeight="semibold"
            >
              {part}
            </Box>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </Box>
  );
}

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
